import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import AdminDashboard from "../../Admin/Dashboard";
import AdvertiserDashboard from "../../Advertiser/Dashboard";
import ScoutDashboard from "../../Scout/Dashboard";
import { useUser } from "../../../../hooks/useUser";
import resetAllStores from "../../../../hooks/resetAllStores";

const Dashboard = () => {
    let navigate = useNavigate();
    const user = useUser();

    useEffect(() => {
        if (user?.category === null) {
            resetAllStores();
            navigate("/");
        }
    }, [user, navigate]);
    
    function getDashboard() {
        if (user?.category === 0) {
            return <AdminDashboard user={user} />
        } else if (user?.category === 1) {
            return <AdvertiserDashboard user={user} />
        } else if (user?.category === 2) {
            return <ScoutDashboard />
        } else {
            return <Typography>There was an error loading the dashboard.</Typography>
        }
    }

    return (
        getDashboard()
    )
}

export default Dashboard;
